'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getHref = getHref;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxHistoryComponent = require('redux-history-component');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getHref(_ref) {
  var href = _ref.href,
      siteId = _ref.siteId;

  if (siteId) return href + '?utm_source=' + siteId;
  return href;
}

function LinkExternal(props) {
  return _react2.default.createElement(_reduxHistoryComponent.Link, _extends({}, props, { href: getHref(props) }));
}
LinkExternal.propTypes = {
  siteId: _propTypes2.default.string,
  href: _propTypes2.default.string.isRequired
};
LinkExternal.defaultProps = {
  siteId: null
};
exports.default = LinkExternal;


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Link/LinkExternal.js
// module id = 689
// module chunks = 0